// /assets/application-form-support.js.liquid -->
$(document).ready(function () {
  // console.log( "application-form-support.js.liquid ready" );
  const $passwordMatchNotice = $('div.custom-password, div.custom-password > div');

  const matchingPasswords = () => {
    const password = $('input#password').val(),
      passwordConfirm = $('input#confirm_password').val();

      if (password !== passwordConfirm){
        $passwordMatchNotice.removeClass('d-none');
        // console.log('unmatched');
      }
      else {
        $passwordMatchNotice.addClass('d-none');
        // console.log('matched');
      }
    //   console.log('matchingPasswords');
  };

  $('input#password, input#confirm_password').on('keyup change', function () {
    matchingPasswords();
  });
});
